import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, Container, CardTitle, CardText, Row, Col, CardImg, CardBody, CardSubtitle } from 'reactstrap';

import product1 from './../../_assets/images/products/waterheater.jpg';
import product2 from './../../_assets/images/products/streetlights.jpg';

import './OurProducts.css';
class OurProducts extends Component {
    render() {
        return (
            <div>
                <Container>
                    <Row>
                        <Col md={12}>
                                <h2 className="h4 mt-4 text-black text-center text-uppercase counterSubText">Our Products</h2>
                            <hr />
                        </Col>
                    </Row>
                    <Row md={10}>
                        <Col md={3}>
                            <Card>
                                <Link to={'./Products'}>
                                    <CardImg top width="100%" src={product1} alt="Card image cap" />
                                </Link>
                                <CardBody>
                                    <CardTitle>Product 1</CardTitle>
                                    <CardSubtitle>product subtitle</CardSubtitle>
                                    <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card>
                                <Link to={'./Products'}>
                                    <CardImg top width="100%" src={product2} alt="Card image cap" />
                                </Link>
                                <CardBody>
                                    <CardTitle>Product 2</CardTitle>
                                    <CardSubtitle>product subtitle</CardSubtitle>
                                    <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card>
                                <Link to={'./Products'} >
                                    <CardImg top width="100%" src={product1} alt="Card image cap" />
                                </Link>
                                <CardBody>
                                    <CardTitle>Product 1</CardTitle>
                                    <CardSubtitle>product subtitle</CardSubtitle>
                                    <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col md={3}>
                            <Card>
                                <Link to={'./Products'} >
                                    <CardImg top width="100%" src={product2} alt="Card image cap" />
                                </Link>
                                <CardBody>
                                    <CardTitle>Product 2</CardTitle>
                                    <CardSubtitle>product subtitle</CardSubtitle>
                                    <CardText>Some quick example text to build on the card title and make up the bulk of the card's content.</CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default OurProducts;